module.exports = __webpack_public_path__ + "static/media/aushang.685ae993.svg";